import { useMutation } from "urql";

import { RejectLimitRequestByCcDocument } from "../../../graphql/generated.ts";

export const useRejectLimitRequestByCC = () =>
  useMutation(RejectLimitRequestByCcDocument);
